module.exports = __webpack_public_path__ + "media/movie-trailer.ef63698d.mp4";